/* tslint:disable */
/* eslint-disable */
/**
 * AIS Database Loader API
 * API for retrieving AIS database and filestore date ranges.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyRangeGet200ResponseDatabase
 */
export interface DailyRangeGet200ResponseDatabase {
    /**
     * The earliest date available in the database.
     * @type {Date}
     * @memberof DailyRangeGet200ResponseDatabase
     */
    begin: Date;
    /**
     * The latest date available in the database.
     * @type {Date}
     * @memberof DailyRangeGet200ResponseDatabase
     */
    end: Date;
}

/**
 * Check if a given object implements the DailyRangeGet200ResponseDatabase interface.
 */
export function instanceOfDailyRangeGet200ResponseDatabase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "begin" in value;
    isInstance = isInstance && "end" in value;

    return isInstance;
}

export function DailyRangeGet200ResponseDatabaseFromJSON(json: any): DailyRangeGet200ResponseDatabase {
    return DailyRangeGet200ResponseDatabaseFromJSONTyped(json, false);
}

export function DailyRangeGet200ResponseDatabaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRangeGet200ResponseDatabase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'begin': (new Date(json['begin'])),
        'end': (new Date(json['end'])),
    };
}

export function DailyRangeGet200ResponseDatabaseToJSON(value?: DailyRangeGet200ResponseDatabase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'begin': (value.begin.toISOString()),
        'end': (value.end.toISOString()),
    };
}

